import _ from "lodash";
import { CollectionAdapter } from "../../main/adapters/CollectionAdapter/CollectionAdapter";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";
import { SourcesService } from "../../presentation/services/SourcesService/SourcesService";
const PointsCollection = new Mongo.Collection("Points", {
    connection: null
});
export class Point extends CollectionAdapter {
    HttpAdapter = new HttpAdapter();
    baseUrlDataTimeseries = `${publicSettings.aws.baseUrls.dataTimeseries}`;

    constructor({ Available, PointCalculated, PopulateManager } = {}) {
        super(PointsCollection);
        this.Available = Available;
        this.PopulateManager = PopulateManager;
        this.PointCalculated = PointCalculated;

        this.sourceOptions = {
            accounting: "a",
            financial: "f",
            fin: "fin",
            covid: "co",
            custom: "c",
            CM: "cm",
            personnel: "p",
            tax: "t",
            simplesNacional: "sn",
            eSocial: "es"
        };

        this.sourcesDictionary = {
            a: "accounting",
            t: "tax",
            p: "personnel",
            fin: "fin",
            f: "fin",
            es: "eSocial",
            sn: "simplesNacional",
            tax: "tax"
        };
    }
    _getSource(source) {
        const sourcesService = new SourcesService();
        return sourcesService.getSourceWithSubSourceArray(source);
    }

    async saveDepartment({ accountingId, points, source, companyId } = {}) {
        await this.saveMany({
            accountingId,
            companyId,
            source,
            scenarioId: "ORIGINAL",
            points
        });

        const newDates = [];

        points.forEach((point) => {
            if (newDates.indexOf(point.time.toISOString()) == -1) {
                newDates.push(point.time.toISOString());
            }
        });

        if (newDates.length) {
            this.Available.saveAndPopulate({
                source,
                newDates,
                companyId
            });
        }

        this.deleteMany({ c: { $eq: companyId }, so: { $eq: source } });
        this.PointCalculated.deleteMany({ c: { $eq: companyId } });
        return true;
    }

    createMany(data = [], companyId) {
        this._before();

        const total = data.length;

        if (!total) return false;

        for (let i = 0; i < total; i++) {
            const document = data[i];

            document.c = companyId;

            this.create(document);
        }

        return true;
    }

    async saveMany({
        accountingId,
        companyId,
        source,
        scenarioId,
        points,
        options
    }) {
        const _points = points.filter((p) => p.time != "Invalid Date");
        const userId = new UserDataAdapter().user()._id;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/point/save-many`,
                {
                    accountingId,
                    companyId,
                    source,
                    scenarioId,
                    userId,
                    points: _points,
                    options
                }
            );
            return response;
        } catch (error) {
            console.error("error", error);
            return false;
        }
    }

    async getByYearAndMonth({ companyId, source, year, month }) {
        if (!companyId || !month || !year) return [];
        let response = null;
        try {
            response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/point/get-by-companyid-date`,
                {
                    companyId,
                    source,
                    date: { year: Number(year), month: Number(month) }
                }
            );
        } catch (error) {
            console.error("error", error);
            response = error;
        }
        return response;
    }

    upsertMany(documents, companyId) {
        try {
            if (documents.length) {
                const serieIds = _.uniq(documents.map((doc) => doc.s));
                const scenarios = _.uniq(documents.map((doc) => doc.sc));
                const times = _.uniq(documents.map((doc) => doc.t));

                this.deleteMany({
                    c: { $eq: companyId },
                    sc: { $in: scenarios },
                    s: { $in: serieIds },
                    t: { $in: times }
                });

                this.createMany(documents, companyId);
            }
        } catch (error) {
            console.error(error);
        }

        return true;
    }

    async createScenario({
        accountingId,
        companyId,
        source,
        name,
        dateStartMonth,
        dateStartYear,
        scenarioIdFrom,
        flatRateValue = null,
        flatRateOperation = null,
        fixedValueOperation = null,
        fixedValue = null,
        type,
        projection = null
    }) {
        const input = {
            accountingId,
            companyId,
            source,
            scenario: {
                type: type,
                name,
                fromId: scenarioIdFrom
            },
            date: {
                start: {
                    year: Number(dateStartYear),
                    month: Number(dateStartMonth)
                }
            },
            userId: new UserDataAdapter().user()?._id,
            options: {}
        };

        if (projection) {
            input.options.projection = projection;
        }

        if (flatRateOperation) {
            input.options.flatRate = {
                value: flatRateValue,
                operation: flatRateOperation
            };
        }

        if (fixedValueOperation) {
            input.options.fixedValue = {
                value: fixedValue,
                operation: fixedValueOperation
            };
        }

        try {
            const { response } = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/point/scenario/create`,
                input
            );

            return response;
        } catch (err) {
            console.log("err", err);
            return null;
        }
    }

    async updateFlatRateBySerie({
        companyId,
        source,
        scenarioId,
        dateStartYear,
        dateStartMonth,
        flatRateValue,
        flatRateOperation,
        replicate,
        serieId,
        unit
    }) {
        const input = {
            companyId: companyId,
            source: source,
            scenarioId: scenarioId,
            date: {
                year: dateStartYear,
                month: dateStartMonth
            },
            updateBy: {
                serie: { _id: serieId, all: replicate }
            }
        };
        if (unit === "percentage") {
            input.flatRate = {
                value: flatRateValue,
                operation: flatRateOperation
            };
        }
        if (unit === "currency") {
            input.fixedValue = {
                value: flatRateValue,
                operation: flatRateOperation
            };
        }
        try {
            const { response } = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/point/scenario-update-flat-rate`,
                input
            );
            return response;
        } catch (err) {
            console.error("err", err);
            return null;
        }
    }

    async updateFlatRateByDate({
        companyId,
        source,
        scenarioId,
        dateStartYear,
        dateStartMonth,
        flatRateValue,
        flatRateOperation,
        replicate,
        unit
    }) {
        const input = {
            companyId,
            source,
            scenarioId,
            date: {
                year: dateStartYear,
                month: dateStartMonth
            },
            updateBy: {
                date: {
                    current: true,
                    all: replicate
                }
            }
        };
        if (unit === "percentage") {
            input.flatRate = {
                value: flatRateValue,
                operation: flatRateOperation
            };
        }
        if (unit === "currency") {
            input.fixedValue = {
                value: flatRateValue,
                operation: flatRateOperation
            };
        }
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/point/scenario-update-flat-rate`,
                input
            );

            return response;
        } catch (err) {
            console.log("err", err);
            return false;
        }
    }

    async removeMany({ companyId, sources, times, all }) {
        if (!companyId || !sources || !times) return false;
        try {
            return await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/point/remove-many`,
                { companyId, sources, times, all }
            );
        } catch (error) {
            return error;
        }
    }
}
